import React, { Component } from 'react';
import howlerIntegration from 'utils/howlerIntegration';

// Load sound data when wrapped component is mounted.
// Can optionally be linked to casinoSoundsOn if properly passed in

const withSoundLoader =
  (soundData, toggleable = false) =>
  BaseComponent => {
    class SoundLoader extends Component {
      componentDidMount() {
        this.loaded = false;
        this.loadSounds();
      }

      componentDidUpdate(prevProps) {
        if (!prevProps.casinoSoundsOn && this.props.casinoSoundsOn) {
          this.loadSounds();
        }
      }

      loadSounds() {
        if (!this.loaded && (!toggleable || this.props.casinoSoundsOn)) {
          this.loaded = true;
          howlerIntegration.addSounds(soundData);
        }
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    }

    return SoundLoader;
  };

export default withSoundLoader;
